import type { CSSProperties } from 'react';

import classNames from 'classnames';

import { computeColor } from '../../utils/colors';

import List from '../../icon/List';
import X from '../../icon/X';
import * as styles from '../Navbar.css';
import type { NavbarMenuBurgerElementProps } from '../Navbar.type';
import { useNavbarMenuBurgerContext } from './context';
import { NAVBAR_MENU_BURGER_DEFAULTS } from './NavbarMenuBurger.constants';

export function NavbarMenuBurger(props: NavbarMenuBurgerElementProps) {
  const { element, className } = props;
  const { color, size, customAttributes } = element.attrs || {};

  const { isOpen, setIsOpen } = useNavbarMenuBurgerContext();

  return (
    // biome-ignore lint/a11y/useValidAriaRole: none
    // biome-ignore lint/a11y/noInteractiveElementToNoninteractiveRole: TODO not sure why?
    <button
      onClick={() => setIsOpen((o) => !o)}
      {...props}
      role="none"
      {...customAttributes}
      className={classNames(styles.navbarMenuBurger, className, customAttributes?.className)}
      style={
        {
          '--text-color': computeColor(color ?? NAVBAR_MENU_BURGER_DEFAULTS.color),
        } as CSSProperties
      }
    >
      {isOpen ? (
        <X size={size || NAVBAR_MENU_BURGER_DEFAULTS.size} weight="bold" />
      ) : (
        <List size={size || NAVBAR_MENU_BURGER_DEFAULTS.size} weight="bold" />
      )}
    </button>
  );
}
